import React from 'react'
import { profile3,profile4,profile5,profile6 } from '../../images'
import "./Testimonial.css"
// import Swiper core and required modules
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

const data = [
  {
    avatar:profile3,
    name:'Relationships',
    review:` Subaru forms close bonds with several characters throughout the series, including Emilia, Rem, Ram, and Beatrice. His relationships with these characters often undergo significant development and contribute to Subaru's growth as a person.`
  },
  {
    avatar:profile4,
    name:'Background',
    review:` Subaru is initially introduced as a typical high school student from Japan who suddenly finds himself transported to a fantasy world. He quickly becomes involved in various conflicts and forms relationships with other characters as he navigates the challenges of this new world.`
  },
  {
    avatar:profile5,
    name:'Character Development',
    review:` Over the course of the series, Subaru experiences significant character development as he confronts his own weaknesses and learns to rely on others. He matures emotionally and gains a deeper understanding of the consequences of his actions.`
  },
  {
    avatar:profile6,
    name:'Role in the Story',
    review:` Subaru is the main protagonist of Re:ZERO. He plays a pivotal role in the story as he uses his Return by Death ability to confront the various challenges and obstacles that threaten the world of Lugnica. Through his actions and choices, he influences the fate of his allies and the outcome of the conflict against the Witch Cult.`
  }

];


const Testimonial = () => {
  return (
    <section id='testimonial'>
      <div className="section__wrapper">
          <div className="section__header">
             <h2 className='primary__title'>Subaru's journey</h2>
             <p className='text__muted description'>
               Subaru Natsuki is the main protagonist of the anime series "Re:Zero - Starting Life in Another World" Here's some information about him:
               <br />
               <br />
               Subaru's journey in "Re:Zero" is marked by both triumphs and tragedies, making him a complex and compelling protagonist in the anime.
             </p>
          </div>
    
          <Swiper className="testimonial__container"
           modules={ [Pagination]}
           spaceBetween={40}
           slidesPerView={1}
           pagination={{ clickable: true }}
           breakpoints={{
            700:{
              slidesPerView:2,
              }
            }
           }
           >
            
            {
              data.map(({avatar,name,review},index) =>{
                return(
            <SwiperSlide key={index} className="testimonial">
              <div className="client__avatar">
                <img src={avatar} alt={review} /> 
              </div>
              
              <h3 className='client__name'>{name}</h3>
                <small className="client__review">
                       {review}
                </small>
            </SwiperSlide>
                )
              })
            }
          </Swiper>
      </div>
    </section>
  )
}

export default Testimonial



/* 

















const data = [
  {
    avatar:AVTR1,
    name:'Samuel Eze',
    review:` Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
           veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea`
  },
  {
    avatar:AVTR2,
    name:'Gloria Chiwendu',
    review:` Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
           veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea`
  },
  {
    avatar:AVTR3,
    name:'Emmanuel Joseph',
    review:` Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
           veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea`
  },
  {
    avatar:AVTR4,
    name:'Peter Stone',
    review:` Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
           veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea`
  }

];

const Testimonials = () => {
  return (
    <section id="testimonials">
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>

      <Swiper className="container testimonials__container"
       modules={ [Pagination]}
       spaceBetween={40}
       slidesPerView={1}
       pagination={{ clickable: true }}>
        
        {
          data.map(({avatar,name,review,index}) =>{
            return(
        <SwiperSlide key={index} className="testimonial">
          <div className="client__avatar">
            <img src={avatar} alt={review} /> 
          </div>
          
          <h5 className='client__name'>{name}</h5>
            <small className="client__review">
                   {review}
            </small>
        </SwiperSlide>
            )
          })
        }
        
       
    
        
    


      </Swiper>
    </section>
  )
}

export default Testimonials


*/
